import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const LandingRequirements = ({ block, onButtonClick }) => {
  const { landingRequirements, title, secondList, secondTitle, className, buttonText } = block
  return (
    <div className={`row align-items-center px-0 px-md-5 ${className}`}>
      <div className='col-12 col-xxl-10 offset-0 offset-xxl-1 p-0 p-lg-5 align-self-center'>
        <div className='col-12 px-5 px-md-0 py-5 py-lg-4'>
          {/* Requirements */}
          <p className='mb-4 fw-bold' style={{ fontSize: '20px' }}>{title || 'Requirements'}</p>
          <div className='pe-0 pe-lg-3'>
            <ul>
              {landingRequirements.map((d, i) => {
                return (
                  <li key={i} className='landing-requirements' data-cy='landing-requirement'>{d}</li>
                )
              })}
            </ul>
          </div>
          {/* Optional Second List */}
          {secondList &&
          <Fragment>
            <p className='mb-4 fw-bold' style={{ fontSize: '20px' }}>{secondTitle || 'Requirements'}</p>
            <div className='pe-0 pe-lg-3'>
              <ul>
                {secondList.map((d, i) => {
                  return (
                    <li key={i} className='landing-requirements' data-cy='landing-requirement'>{d}</li>
                  )
                })}
              </ul>
            </div>
          </Fragment>
          }
          <button className='btn btn-sm btn-primary mt-2' data-cy='landing-requirements' onClick={onButtonClick}>{buttonText}</button>
        </div>
      </div>
    </div>
  )
}

LandingRequirements.propTypes = {
  block: PropTypes.object,
  onButtonClick: PropTypes.func
}

export default LandingRequirements
